import { render, staticRenderFns } from "./Procedures.vue?vue&type=template&id=8d647602&scoped=true&"
import script from "./Procedures.vue?vue&type=script&lang=js&"
export * from "./Procedures.vue?vue&type=script&lang=js&"
import style0 from "./Procedures.vue?vue&type=style&index=0&id=8d647602&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d647602",
  null
  
)

export default component.exports